/* eslint-disable spire/export-styles */
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { WarehouseDto } from "@insite/client-framework/Types/ApiModels";
import ProductAvailability, {
    ProductAvailabilityStyles,
} from "@MasterBluePrint/Overrides/Components/ProductAvailability";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    isProductDetailsPage?: boolean;
    configurationCompleted?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
    isCarouselProduct?: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const path = location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname;
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    return {
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        breadcrumbLinks: state.components.breadcrumbs.links,
        includeRealTimeInventoryAndPricingForSeo:
            getSettingsCollection(state).websiteSettings.includeRealTimeInventoryAndPricingForSeo,
    };
};
type Props = OwnProps & HasProduct & ReturnType<typeof mapStateToProps>;
const ProductContextAvailability = ({
    productInfo,
    product,
    isProductDetailsPage,
    configurationCompleted,
    extendedStyles,
    category,
    breadcrumbLinks,
    isCarouselProduct,
    includeRealTimeInventoryAndPricingForSeo,
}: Props) => {
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;

    let categoryName = category?.name;

    let warehousesLoaded = false;

    if (breadcrumbLinks !== undefined && breadcrumbLinks.length > 0) {
        const breadScrumCategoryName =
            breadcrumbLinks?.length !== undefined && breadcrumbLinks?.length > 1
                ? breadcrumbLinks[breadcrumbLinks.length - 2]?.children?.toString()
                : "";
        categoryName = category?.name ?? breadScrumCategoryName;
    }

    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    let warehousesResult: { errorMessage: String; warehouses: WarehouseDto[] } = {
        errorMessage: "Inventory is not currently available",
        warehouses: [],
    };
    if (inventory && inventory?.inventoryWarehousesDtos) {
        warehousesLoaded = true;
        const inventoryWarehousesDto = inventory?.inventoryWarehousesDtos.find(
            o => o.unitOfMeasure.toLowerCase() === unitOfMeasure.toLowerCase(),
        );

        if (inventoryWarehousesDto && inventoryWarehousesDto.warehouseDtos) {
            warehousesResult = {
                warehouses: inventoryWarehousesDto.warehouseDtos,
                errorMessage: "",
            };
        }
    }
    if (
        (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) ||
        product.isVariantParent ||
        (!!product.configurationType &&
            product.configurationType !== ConfigurationType.None &&
            product.configurationType !== ConfigurationType.Fixed &&
            !configurationCompleted)
    ) {
        return null;
    }
    if (warehousesLoaded && product.currentWebsiteCountry) {
        return (
            <ProductAvailability
                productId={product.id}
                trackInventory={product.trackInventory}
                availability={availability}
                unitOfMeasure={unitOfMeasure}
                isProductDetailsPage={isProductDetailsPage}
                failedToLoadInventory={failedToLoadInventory}
                extendedStyles={extendedStyles}
                qtyOnHand={productInfo.inventory?.qtyOnHand ?? 0}
                isDirectShip={product.properties?.isDirectShip ?? false}
                manufacturerItem={product?.manufacturerItem ?? false}
                isDirectShipFromManufacturer={product.properties?.isDirectShipFromManufacturer ?? false}
                inventoryOutofStock={product.properties?.inventoryOutofStock ?? ""}
                currentWebsiteCountry={product.currentWebsiteCountry}
                warehousesResult={warehousesResult}
                softwareProduct={product.properties?.software_Product ?? false}
                calibrationService={product.properties?.calibrationService ?? false}
                isCarouselProduct={isCarouselProduct}
            />
        );
    }
    return null;
};

export default connect(mapStateToProps)(withProduct(ProductContextAvailability));
